import { API_URL, jwtToken } from "../../../context/appContext";
export default async function updateUser(data) {
    return fetch(`${API_URL}/api/user`, {
        method: "PUT",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }, body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
